import { useLoader } from "@react-three/fiber"
import * as THREE from 'three'

import { loadModel } from './loadModel'

// ============================================================
// Modelli di SCENA del negozio: edificio (baked), piante del
// parcheggio, vetrate. La rappresentazione dei PRODOTTI
// (scatole, GLB dedicati, anello sconto) sta in ProductBox.jsx.
// ============================================================

export function MainModel() {
  const bakedTexture = useLoader(THREE.TextureLoader, 'textures/bakedTexture.jpg')
  bakedTexture.flipY = false
  bakedTexture.colorSpace = THREE.SRGBColorSpace

  const bakedMaterial = new THREE.MeshBasicMaterial({
    map: bakedTexture,
    side: THREE.DoubleSide
  })

  const mainModel = loadModel('models/baseModel-draco.glb')
  mainModel.scene.children[0].material = bakedMaterial

  const P104Model = loadModel('models/104P-draco.glb')
  P104Model.scene.children[0].material = bakedMaterial

  return <>
    <primitive object={mainModel.scene} />
    <primitive object={P104Model.scene} />
  </>
}

export function PlantsParkingSpotModel() {
  const plantsParkingSpotModel = loadModel('models/plantsParkingSpot-draco.glb')
  const bakedTexture = useLoader(THREE.TextureLoader, 'textures/bakedPlantsAlpha.avif')
  bakedTexture.flipY = false
  bakedTexture.colorSpace = THREE.SRGBColorSpace

  const bakedPlantsMaterial = new THREE.MeshBasicMaterial({
    map: bakedTexture,
    transparent: true,
    side: THREE.DoubleSide,
    alphaTest: 0.4,
  })

  plantsParkingSpotModel.scene.children[0].material = bakedPlantsMaterial

  return <>
    <primitive object={plantsParkingSpotModel.scene} />
  </>
}

export function GlassModel() {
  const glassModel = loadModel('models/glassWmaterial.glb')
  const glassMaterial = new THREE.MeshPhongMaterial({
    transparent: true,
    opacity: 0.13,
    color: 0x000000,
    shininess: 0.5,
    emissive: 0xffffff,
    reflectivity: 1,
    refractionRatio: 0.98,
  })

  glassModel.scene.children[0].material = glassMaterial

  return <>
    <primitive object={glassModel.scene} />
  </>
}
